import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import PropTypes from 'prop-types';
import React from 'react';
import { ComponentsProvider, ACTIONS_NAMESPACE } from '@panneau/core/contexts';
import actionDelete from '@panneau/action-delete';
import actionDuplicate from '@panneau/action-duplicate';
import actionEdit from '@panneau/action-edit';
import actionImport from '@panneau/action-import';
import actionRestore from '@panneau/action-restore';
import actionShow from '@panneau/action-show';
import actionUpload from '@panneau/action-upload';

var components = /*#__PURE__*/Object.freeze({
    __proto__: null,
    Delete: actionDelete,
    Duplicate: actionDuplicate,
    Edit: actionEdit,
    Import: actionImport,
    Restore: actionRestore,
    Show: actionShow,
    Upload: actionUpload
});

var _excluded = ["components", "children"];
var propTypes = {
  components: PropTypes.object,
  // eslint-disable-line
  children: PropTypes.node
};
var defaultProps = {
  components: null,
  children: null
};
var ActionsProviders = function ActionsProviders(_ref) {
  var injectedComponents = _ref.components,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(ComponentsProvider, Object.assign({
    namespace: ACTIONS_NAMESPACE,
    components: _objectSpread(_objectSpread({}, components), injectedComponents)
  }, props), children);
};
ActionsProviders.propTypes = propTypes;
ActionsProviders.defaultProps = defaultProps;

export { ActionsProviders as default };
